import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";

import PublicLayout from "./components/PublicLayout";
import Home from "./pages/public/Home";
import Services from "./pages/public/Services";
import Work from "./pages/public/Work";
import HowItWorks from "./pages/public/HowItWorks";
import About from "./pages/public/About";
import Pricing from "./pages/public/Pricing";
import Contact from "./pages/public/Contact";
import Creative from "./pages/public/Creative";
import PaymentResult from "./pages/PaymentResult";

const CREATIVE_ENABLED = false;
import Login from "./pages/Login";

import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import Leads from "./pages/admin/Leads";
import Contacts from "./pages/admin/Contacts";
import Companies from "./pages/admin/Companies";
import Projects from "./pages/admin/Projects";
import ProjectDetail from "./pages/admin/ProjectDetail";
import Tasks from "./pages/admin/Tasks";
import CMS from "./pages/admin/CMS";
import Quotes from "./pages/admin/Quotes";
import Users from "./pages/admin/Users";
import Availability from "./pages/admin/Availability";
import QuoteEditor, { QuoteOpen } from "./pages/admin/QuoteEditor";
import Invoices from "./pages/admin/Invoices";
import Reports from "./pages/admin/Reports";
import Promotions from "./pages/admin/Promotions";
import PostQueue from "./pages/admin/PostQueue";
import SetPassword from "./pages/SetPassword";

import ClientLayout from "./pages/client/ClientLayout";
import ClientDashboard from "./pages/client/ClientDashboard";
import ClientProject from "./pages/client/ClientProject";
import ClientProfile from "./pages/client/ClientProfile";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/work" element={<Work />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/about" element={<About />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/creative" element={CREATIVE_ENABLED ? <Creative /> : <Navigate to="/services" replace />} />
          </Route>

          <Route path="/login" element={<Login />} />
          <Route path="/set-password" element={<SetPassword />} />
          <Route path="/payment/success" element={<PaymentResult />} />
          <Route path="/payment/cancel" element={<PaymentResult cancelled />} />

          <Route path="/admin" element={<ProtectedRoute roles="staff"><AdminLayout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="leads" element={<Leads />} />
            <Route path="contacts" element={<Contacts />} />
            <Route path="companies" element={<Companies />} />
            <Route path="projects" element={<Projects />} />
            <Route path="projects/:id" element={<ProjectDetail />} />
            <Route path="projects/:id/quote" element={<QuoteEditor />} />
            <Route path="projects/:id/:widget" element={<ProjectDetail />} />
            <Route path="quotes/new" element={<QuoteEditor />} />
            <Route path="quotes/:qid" element={<QuoteOpen />} />
            <Route path="invoices" element={<Invoices />} />
            <Route path="reports" element={<Reports />} />
            <Route path="promotions" element={<Promotions />} />
            <Route path="post" element={<PostQueue />} />
            <Route path="tasks" element={<Tasks />} />
            <Route path="availability" element={<Availability />} />
            <Route path="quotes" element={<Quotes />} />
            <Route path="cms" element={<CMS />} />
            <Route path="users" element={<Users />} />
          </Route>

          <Route path="/client" element={<ProtectedRoute roles="client"><ClientLayout /></ProtectedRoute>}>
            <Route index element={<ClientDashboard />} />
            <Route path="profile" element={<ClientProfile />} />
            <Route path="projects/:id" element={<ClientProject />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
